import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propFunc, propShape, propStr, propChildren, } from '../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../helpers/recompose';
import TransitionHoc from '../../../../../Ui/Transition/TransitionHoc';
import SlideSearchHeaderSideMenuSpButtons from './Buttons';
import SlideSearchHeaderSideMenuSpHeader from './Header';
import SlideSearchHeaderSideMenuSpList from './List';
import SlideSearchHeaderSideMenuSpLogout from './Logout';
import SlideSearchHeaderSideMenuSpOthers from './Others';
import SlideSearchHeaderSideMenuSpProfile from './Profile';
const SlideSearchHeaderSideMenuSp = (props) => {
    const { actionButtonProps, className, hideMenu, links, onClickLogout, planComponent, profile, transitionState, } = props;
    return (_jsxs("div", Object.assign({ className: `slide_search_header_side_menu_sp ${className} ${transitionState}` }, { children: [_jsx("div", { className: 'bg', onClick: hideMenu, role: 'presentation' }), _jsx("div", Object.assign({ className: 'menu_inner' }, { children: _jsxs("div", Object.assign({ className: 'menu_body' }, { children: [_jsx(SlideSearchHeaderSideMenuSpHeader, { hideMenu: hideMenu }), _jsx(SlideSearchHeaderSideMenuSpProfile, { hideMenu: hideMenu, planComponent: planComponent, profile: profile }), _jsx(SlideSearchHeaderSideMenuSpButtons, { links: links }), _jsx(SlideSearchHeaderSideMenuSpList, { links: links }), _jsx(SlideSearchHeaderSideMenuSpOthers, { actionButtonProps: actionButtonProps, links: links }), _jsx(SlideSearchHeaderSideMenuSpLogout, { onClickLogout: onClickLogout })] })) }))] })));
};
SlideSearchHeaderSideMenuSp.propTypes = {
    actionButtonProps: propShape().isRequired,
    className: propStr(),
    hideMenu: propFunc().isRequired,
    links: propShape().isRequired,
    onClickLogout: propFunc().isRequired,
    planComponent: propChildren().isRequired,
    profile: propShape().isRequired,
    transitionState: propStr().isRequired,
};
SlideSearchHeaderSideMenuSp.defaultProps = {
    className: '',
};
const enhance = compose(TransitionHoc);
export default enhance(SlideSearchHeaderSideMenuSp);
